<template>
   <v-layout row pb-2>

        <Menu  />  <!-- Menu -->

        <v-dialog
            v-model="connectOpen"
            width="400"

          >
            <ConnectContract v-if="connectOpen && !ConnectBasicAccount"  @connectClosed="connectOpen = false" :open="connectOpen">
            </ConnectContract>
            
        </v-dialog>

      <!--   <v-dialog
            v-model="connectBasicAccountOpen"
            width="1200"

          >
            <ConnectBasicAccount v-if="connectBasicAccountOpen && !connectOpen"  @connectClosed="connectBasicAccountOpen = false" :open="connectBasicAccountOpen">
            </ConnectBasicAccount>
            
        </v-dialog> -->
      <v-flex xs12 v-if="myContracts.Count > 0 && myAccounts.Count > 0">
        <v-flex xs12>
          
          <v-container grid-list-xl>
            <span class="headline" data-v-step="0" style="margin-left:20px;" >My contract</span>

              <v-layout wrap>


                <v-flex class="d-flex"
                  color="grey lighten-3"
                   
                   xs12 sm6 md6 offset-sm1 offset-md2>


                  <v-flex xs12>

                    <!-- <v-dialog
                      v-model="dialog"
                      width="400px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="blue darken-2"
                          dark
                          v-on="on"
                          style="text-transform:capitalize"
                        >
                          demo video
                        </v-btn>
                      </template>

                      <v-card>
                        <iframe v-if="dialog" style="opacity:rgba(0,0,0,0.1)" width="400px" height="280px"  src="https://www.youtube.com/embed/6kK6xj47jNs"></iframe>
                      </v-card>
                    </v-dialog> -->

                    <v-card  :key=" trimTokenDecimals(myAccountBalances, myContracts.Items[0].account_name.S)"  min-width="350px" style="margin:10px; padding:30px; border-radius:2% 2% 2% 2%">
                      <img
                        src="../assets/contractTabSelect/db.png"
                        height="120px"
                        v-if="myContracts.Items[0].type.S == 'database'"
                        style="padding:15px; "
                      >
                      </img>

                      <img
                        src="../assets/contractTabSelect/token.png"
                        height="120px"
                        v-else-if="myContracts.Items[0].type.S == 'token'"
                        style="padding:15px;  "
                      >
                      </img>

                      <img
                        src="../assets/contractTabSelect/nft.png"
                        height="120px"
                        v-else-if="myContracts.Items[0].type.S == 'nft'"
                        style="padding:15px; "
                      >
                      </img>

                      <v-card-title  primary-title>
                        <div>
                          <span class="title"   style="padding:0px">{{myContracts.Items[0].name.S}}</span></br></br>
                          <!-- 
                          <span class="" style="padding:0px">Ref:  <strong>contract-{{myContracts.Items[0].account_name.S}}</strong></span></br> -->
                          <span class="" style="padding:0px">Account:  <a target="_blank" :href="'https://telos.eosx.io/account/' + myContracts.Items[0].account_name.S"><strong>{{myContracts.Items[0].account_name.S}}</strong></a></span></br> 
                          <span class="" style="padding:0px">Contract type: <strong>{{myContracts.Items[0].type.S}}</strong></span></br>
                          <span :key="keyUpdate"  class="" style="padding:0px">Balance: <strong  :key="keyUpdate">{{ trimTokenDecimals(myAccountBalances, myContracts.Items[0].account_name.S) }}</strong></span></br>
                          <span :key="keyUpdate + '1'" v-if="!myAccountBalances" class="" style="padding:0px"> Balance: loading..</span></br>
                        </br>
                        </div>
                      </v-card-title>

                      <v-card-actions>
                   
                        <v-btn class="pulse-button" data-v-step="1" round v-if="myContracts.Items[0].contract_status.S != 'online'" color="green" dark @click="connectOpen = true">Start</v-btn>

                        <!-- <v-btn  round v-if="contract.contract_status.S == 'online'" color="green" dark @click="connectOpen = true">Actions</v-btn> -->
                        <v-spacer></v-spacer>
                        <v-btn  outline @click="contractActionDialog = true; actionDialog = true"><strong>Actions</strong></v-btn>
                      </v-card-actions>
                    </v-card>
                    
    
                    <v-flex xs12>
                      <v-list v-if="contractActivity.Items" style="background-color:rgba(0,0,0,0)" two-line>
                        <span style="font-weight:600; margin-bottom:20px; display:block">
                          Contract activity logs
                        </span>
                        <p  v-if="!contractActivity.Items[0]" style="color:silver">No actions recorded yet</p>

                        <template  v-if="!contractActivity.Items[0]">
                          <v-list-tile-content style="margin-left:25px;" >
                            <v-list-tile-title>From party A to party B</v-list-tile-title>
                             <v-list-tile-sub-title style="margin-left:10px;"  v-html="'From: the Smartpress team :)'"></v-list-tile-sub-title>
                             <v-list-tile-sub-title style="margin-left:10px;"  v-html="'To: You!'"></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>

                        <template :key="" v-for="(item, index) in orderedLogs">
                          <v-list-tile-content style="margin-left:25px;" >
                            <v-list-tile-title style="text-transform:capitalize" v-html="item.action_type.S + ' ' + item.no_units.N + ' token'"></v-list-tile-title>
                             <v-list-tile-sub-title style="margin-left:10px;"  v-html="'From: ' + item.primary_actor.S"></v-list-tile-sub-title>
                             <v-list-tile-sub-title style="margin-left:10px;"  v-html="'To: ' + item.secondary_actor.S"></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-flex>
                  

                  <v-flex xs12>
                    <v-card dark min-width="250px"  :key="contract.contract_id"  v-for="contract in myAccounts.Items" style="margin: 12px 10px 8px 0px;background-color:rgb(87, 100, 228); border-radius: 2% 2% 2% 2%" >
                      <img

                        height="40px"
                        style="margin-left:10px;"

                      > 
                       <v-icon  style="color:white;margin:30px 0 0 10px; font-size:40px" large>account_circle</v-icon>
                      </img>

                      <v-card-title  primary-title>
                        <div>
                          <span  class="title" style="margin-top:0px;padding:10px">User account</span></br></br>
                          <!-- <span class="" style="padding:10px">Ref:  <strong>admin-{{contract.account_name.S}}</strong></span></br> -->
                          <span class="" style="padding:10px">Account:  <a target="_blank" style='color:rgb(50, 1500, 100)' :href="'https://telos.eosx.io/account/' + contract.account_name.S"><strong>{{contract.account_name.S}}</strong></a></span></br>
                          <span class="" style="padding:10px">Contract type: <strong>{{contract.type.S}}</strong></span></br>
                          <span :key="keyUpdate + '3'" v-if="myAccountBalances" class="" style="padding:10px">Balance: <strong>{{ trimTokenDecimals(myAccountBalances, contract.account_name.S) }}</strong></span></br>
                          <span :key="keyUpdate + '2'" v-if="!myAccountBalances" class=""  style="padding:10px">Balance: loading..</span></br></br>

                          <span class="" style="padding:10px; font-size:12px">User_Id: {{contract.user_id.S}}</span></br>
                          
                        </div>
                      </v-card-title>
                      <v-card-actions  data-v-step="2">
                        <v-spacer></v-spacer> 
                      </v-card-actions>
                    </v-card>

                    
                  </v-flex>
                </v-flex>
              </v-layout>
          </v-container>
        </v-flex>
      </v-flex>

      <TokenSelector  v-if="contractActionDialog" v-on:closeActionDialog="closeActionDialog()"></TokenSelector>
<!-- 
      <v-jumbotron
        color="white"
        dark
        style="height:615px; padding:100px;"
        
      >

      <iframe width="600" height="415"src="https://youtube.com/embed/_TLMqRCijXY"></iframe>

      </v-jumbotron> -->

    </v-layout>
 
</template>

<script>
import { mapState } from 'vuex'
import dbcompile  from '../components/db-compile/SecureDeploy'
import store from "@/store"
import router from "@/router"
import TokenSelector  from '../components/actions/TokenSelector'
import TransferToken  from '../components/actions/TransferToken'
import actionPopup  from '../components/actions/actionPopup'
import ConnectContract  from '../components/Documentation/ConnectContract'
import ConnectBasicAccount  from '../components/Documentation/ConnectBasicAccount'
import Menu  from '../components/Menu'




export default {
    components: {
      dbcompile,
      TokenSelector,
      ConnectContract,
      ConnectBasicAccount,
      Menu,
      TransferToken,
      actionPopup
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            myAccountBalances: state => state.contractsDb.myAccountBalances,
            myContractKeys: state => state.contractsDb.myContractKeys,
            contractActivity: state => state.contractsDb.contractActivity,
            myAccounts: state => state.contractsDb.myAccounts,
            myContracts: state => state.contractsDb.myContracts,
            myApiKey: state => state.contractsDb.myContracts,
            transactionStatus: state => state.contractsDb.transactionStatus,
            // message: state => state.util.message,
        })
    },
    created: function () {
      // this.$store.dispatch('contractsDb/getContractActivity')
      // this.$store.dispatch('contractsDb/getMyContracts')

      
      // dont remove
      console.log('hello')
      this.$store.dispatch('contractsDb/getUser')
      this.$store.dispatch('contractsDb/getMyUsers')
      this.$store.dispatch('contractsDb/getMyAccounts')
      this.$store.dispatch('contractsDb/getMyContracts')

      let self = this
      setTimeout(function () {

        self.pageReady = true;

        self.$store.dispatch('contractsDb/getCurrencyBalances', {
          account:self.myContracts.Items[0].account_name.S,
          contract:self.myContracts.Items[0].account_name.S,
          symbol:'AAA'
        })

        self.$store.dispatch('contractsDb/getContractActivity', {
          account_name: self.myContracts.Items[0].account_name.S
        })
       
      }, 7000)
      setTimeout(function () {
        if (self.myAccounts.Items) {
          (self.myAccounts.Items).map((account) => {
            self.$store.dispatch('contractsDb/getCurrencyBalances', {
              account:account.account_name.S,
              contract:self.myContracts.Items[0].account_name.S,
              symbol:'AAA'
            })
          });
          setTimeout(function () {
            self.forceRender()
          }, 2000)
        } else {
          window.location.reload();
        }
        
      }, 7000)


      // sort contract logs
      if (this.contractActivity.Items) {
        this.orderedLogs = (this.contractActivity.Items).slice(0);
        this.orderedLogs.sort(function(a, b) {
          a = a.time.N
          b = b.time.N
          return b - a;
        });
      }

      
    },
    mounted: function() {

      // if (this.myAccounts.Count == 0) {
      //   console.log('createing account')
      //   this.$store.dispatch('contractsDb/pushNewContract', {
      //     type: 'user',
      //     name: 'userAccount',
      //     contract_status: 'pending'
      //   })
      // }

      // this.$cookies.set("newContractShouldTour", 'true')
      
      // // Start tour
      // if (this.$cookies.get('newContractShouldTour') == 'true') {
      //   this.$tours['introTour'].start()
      //   this.$cookies.remove('newContractShouldTour')
      // }
      

    },
    watch: {
      myContracts: function () {
        console.log(this.myContracts)
        this.$store.dispatch('contractsDb/getCurrencyBalances', {
          user_id:this.myContracts.Items[0].account_name.S,
          contract:this.myContracts.Items[0].account_name.S,
          symbol:'AAA'
        })
      },
      myAccountBalances: function () {
        console.log(this.myAccountBalances)
        this.forceRender()
      },
      myContractAccessKeys: function () {
        console.log(this.myContractAccessKeys)
        this.$store.dispatch('contractsDb/getContractKey')
      },
      contractActivity: function () {
        this.orderedLogs = (this.contractActivity.Items).slice(0);
        this.orderedLogs.sort(function(a, b) {
          a = a.time.N
          b = b.time.N
          
          return b - a;
        });
      },
    },

    methods: {
      forceRender: function () {
        this.keyUpdate++
        console.log('FORCED UPDATE !!')
      },
      maxCharacters: function  (string, length) {
        var trimmedString = string.substring(0, length);
        return trimmedString
      },
      closeActionDialog: function () {
        this.actionDialog = false
        this.contractActionDialog = false
      },
      sendEmail: function () {
        this.$store.dispatch("contractsDb/email")
      },
      openTemplates() {
        router.push("contractTemplates")
      },
      trimTokenDecimals(number, acc_name) {
        if (number != undefined) {
          if (number[acc_name]) {
            number = number[acc_name]
            if (number[0]) {
              number = number[0].split(" ")
              return Number(number[0])
            } else {
              return 0
            }
            // return Number(number[0]) + " " + number[1]
          }
        }
        
        
      },
      getMyContracts() {
        this.$store.dispatch('contractsDb/getContractKey')
        // this.$store.dispatch('contractsDb/getMyContracts')
      },
      logMyKeys() {
          console.log('asdfsdafsdfgdfg')
        // console.log(this.myContractKeys)
      },
      readMyContracts() {
        console.log(this.myContracts)
      },
      getMyKey() {
        this.$store.dispatch('contractsDb/getContractKey')
      },
      getMyBalance() {
        this.$store.dispatch('contractsDb/getCurrencyBalances')
      },
      newUser() {
        this.$store.dispatch('contractsDb/newUser',
          this.user
        )
      },
      selectAction(value) {
        console.log('action click ' + value)
        if (value == 'transfer') {
          this.actionTrigger.transferToken = true
        } else if (value == 'issue') {
          this.actionTrigger.issueToken = true
        } else if (value == 'create') {
          this.actionTrigger.createToken = true
        } else {
          console.log("unkown action name in 'selectAction' method")
        }
        console.log(this.actionTrigger.issueToken)
      },
      selectContract(value) {
        console.log('contract click ' + value)
      },
      toggle (index) {
        const i = this.selected.indexOf(index)

        if (i > -1) {
          this.selected.splice(i, 1)
        } else {
          this.selected.push(index)
        }
      }
    },
    watch: {
      connectOpen: function () {
        console.log(this.connectOpen)
      }
    },
    data () {
      return {
        // ordering the logs by time
        orderedLogs: [],
        pageReady: false,
        keyUpdate: 0,
        // introTourSteps: [
        //   {
        //     target: '[data-v-step="0"]',
        //     content: 'Welcome to your accounts page, this isnt your usual kind of account, this is a blockchain account. An account can have a smart contract running on it, or it can be a basic account that you can use to interact with smart contracts.',
        //     params: {
        //       placement: 'top'
        //     }
        //   },
        //   {
        //     target: '[data-v-step="1"]',
        //     content: 'This account is running the smart contract you chose, it has an account name you can click to see it on a block explorer. Right now the contract is under our control, to claim it for your app click the claim button below.',
        //     params: {
        //       placement: 'left'
        //     }
        //   },
        //   {
        //     target: '[data-v-step="2"]',
        //     content: 'This account is a basic account. This is what you should use day to day, the smart contract account on the left side is like an admin account for your contract, and this is your personal account.',
        //     params: {
        //       placement: 'right'
        //     }
        //   }
        // ],
        mainContract: {
          // logItems: [
          //   { header: 'fd' },
          //   {
          //     icon: 'account_circle',
          //     title: '<span>No activity to log yet</span>',
          //     subtitle: "<span class='text--primary'>Intergrate</span> your contract to get started"
          //   },
          // ]
          logItems: [
            { header: 'Today' },
            {
              icon: 'account_circle',
              title: 'Transfer: <span class="grey--text text--lighten-1">Game credit</span>',
              subtitle: "<span class='text--primary'>John425423</span> &mdash; <span class='text--primary'>Jess35364</span> | 3.5000 game credits"
            },
            { divider: true, inset: true },
            {
              icon: 'account_circle',
              title: 'Create asset: <span class="grey--text text--lighten-1">Star credit</span>',
              subtitle: "<span class='text--primary'>John425423</span> | 1000.000 star credits"
            },
            { divider: true, inset: true },
            {
              icon: 'account_circle',
              title: 'Create asset: <span class="grey--text text--lighten-1">Star collectable 001</span>',
              subtitle: "<span class='text--primary'>Jess35364</span> | 1 star collectable"
            }
          ]
        },
        actionDialog: true,
        step: 0,
        dialog: false,
        connectOpen: false,
        connectBasicAccountOpen: false,
        contractActionDialog: false,
        selected: [2],
        items: [
          {
            action: '15 min',
            headline: 'TESTNET',
            title: 'Token Contract',
            subtitle: "running* http://xxx.com"
          }
        ],
        gradient: 'to top right, rgba(255,255,255, .7), rgba(230,230,200, .7)'
      }
    }
}

</script>

<style>

  .box:before {
    content: "";
    position: absolute;
    top: 50%;                         
    margin-top: -15px;                
    left:-25px;
    border: solid 10px transparent;
    border-right: solid 15px #796EFF;
    z-index: 1;
}
 
</style>
